import React, { useEffect, useState } from "react";

import { getAllUsers } from "../../services/users";

import SelectOption from "../SelectOption";

import styles from "../ChangeServiceLineForm/ChangeServiceLineForm.module.scss";

export const ChangeContigoResponsibleForm = () => {
  const [responsiblesOptions, setResponsiblesOptions] = useState([]);

  const getResponsibles = async () => {
    try {
      const { response = [] } = await getAllUsers();
      if (!response.length) setResponsiblesOptions([])
      else setResponsiblesOptions(response);
    } catch (error) {
      console.error(error);
      setResponsiblesOptions([]);
    }
  };

  useEffect(() => {
    getResponsibles();
  }, []);

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>Nuevo responsable</h2>
      <SelectOption
        name="responsible"
        className={styles.selectInput}
      >
        <option value="" disabled>
          Elige el nuevo profesional a cargo
        </option>
        {responsiblesOptions.map(({ id, name }) => (
          <option key={id} value={`${name}:${id}`}>
            {name}
          </option>
        ))}
      </SelectOption>
    </section>
  );
};
